import Registry from '../plugins/Registry';

class Loader {
    static instance(selector) {
        let instance = Registry.get('Loader', selector);
        if (instance)
            return instance;

        instance = new Loader(selector);
        Registry.set('Loader', selector, instance);

        return instance;
    }

    static getHTML() {
        return `
            <div class="loader" style="display: none;">
                <div class="loader__wrapper">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        `;
    }

    constructor(selector) {
        this.selector = selector;
        if (typeof selector === 'string') {
            $(this.selector).append(Loader.getHTML());
            this.loader = $(this.selector).children('.loader');
        }
        else {
            this.selector.append(Loader.getHTML());
            this.loader = this.selector.children('.loader');
        }

        return this;
    }

    setFullScreen(value) {
        this.fullScreen = value;

        if (value) {
            this.loader.addClass('loader_full');
        }

        return this;
    }

    start() {
        this.loader.show();

        if (this.fullScreen)
            $('html').addClass('no-scroll');

        return this;
    }

    stop() {
        this.loader.hide();

        if (this.fullScreen)
            $('html').removeClass('no-scroll');

        return this;
    }

    destroy() {
        this.loader.remove();

        if (this.fullScreen)
            $('html').removeClass('no-scroll');

        Registry.forget('Loader', this.selector);

        return undefined;
    }
}

export default Loader;